export default "__VITE_ASSET__B1Al$1PP__"